import { NgIf, NgTemplateOutlet } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, ElementRef, Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgDocDecodeUriComponentPipe } from '@ng-doc/app/pipes';
import { NgDocIconComponent } from '@ng-doc/ui-kit';
import { LOCATION } from '@ng-web-apis/common';
const _c0 = ["*"];
function NgDocPageLinkComponent_a_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgDocPageLinkComponent_a_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 3);
    i0.ɵɵpipe(1, "decodeUriComponent");
    i0.ɵɵtemplate(2, NgDocPageLinkComponent_a_0_ng_container_2_Template, 1, 0, "ng-container", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(ctx_r0.classes);
    i0.ɵɵproperty("routerLink", ctx_r0.path)("fragment", ctx_r0.fragment ? i0.ɵɵpipeBind1(1, 6, ctx_r0.fragment) : undefined)("queryParams", ctx_r0.queryParams);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
  }
}
function NgDocPageLinkComponent_a_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function NgDocPageLinkComponent_a_1_ng_doc_icon_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 7);
  }
}
function NgDocPageLinkComponent_a_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 5);
    i0.ɵɵtemplate(1, NgDocPageLinkComponent_a_1_ng_container_1_Template, 1, 0, "ng-container", 4)(2, NgDocPageLinkComponent_a_1_ng_doc_icon_2_Template, 1, 0, "ng-doc-icon", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const content_r2 = i0.ɵɵreference(3);
    i0.ɵɵclassMap(ctx_r0.classes);
    i0.ɵɵproperty("href", ctx_r0.path, i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", content_r2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.isInCode);
  }
}
function NgDocPageLinkComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
let NgDocPageLinkComponent = /*#__PURE__*/(() => {
  class NgDocPageLinkComponent {
    constructor() {
      this.href = '';
      this.classes = '';
      this.isInCode = false;
      this.location = inject(LOCATION);
      this.elementRef = inject(ElementRef);
    }
    ngOnInit() {
      this.isInCode = this.elementRef.nativeElement.closest('code') !== null;
    }
    ngOnChanges() {
      this.link = new URL(this.href, this.location.origin);
    }
    get isExternalLink() {
      return this.link?.origin !== this.location.origin;
    }
    get path() {
      return (!this.isExternalLink ? this.link?.pathname : this.href) ?? '';
    }
    get fragment() {
      return this.link?.hash.replace(/^#/, '') || undefined;
    }
    get queryParams() {
      return Object.fromEntries(this.link?.searchParams.entries() ?? []);
    }
    static {
      this.ɵfac = function NgDocPageLinkComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocPageLinkComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocPageLinkComponent,
        selectors: [["ng-doc-page-link"]],
        inputs: {
          href: "href",
          classes: "classes"
        },
        standalone: true,
        features: [i0.ɵɵNgOnChangesFeature, i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 2,
        consts: [["content", ""], [3, "class", "routerLink", "fragment", "queryParams", 4, "ngIf"], ["target", "_blank", 3, "class", "href", 4, "ngIf"], [3, "routerLink", "fragment", "queryParams"], [4, "ngTemplateOutlet"], ["target", "_blank", 3, "href"], ["icon", "external-link", 4, "ngIf"], ["icon", "external-link"]],
        template: function NgDocPageLinkComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, NgDocPageLinkComponent_a_0_Template, 3, 8, "a", 1)(1, NgDocPageLinkComponent_a_1_Template, 3, 5, "a", 2)(2, NgDocPageLinkComponent_ng_template_2_Template, 1, 0, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isExternalLink);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isExternalLink);
          }
        },
        dependencies: [NgIf, RouterLink, NgTemplateOutlet, NgDocIconComponent, NgDocDecodeUriComponentPipe],
        styles: ["[_nghost-%COMP%]{white-space:nowrap}[_nghost-%COMP%]   ng-doc-icon[_ngcontent-%COMP%]{margin-left:calc(var(--ng-doc-base-gutter) / 2);--ng-doc-icon-color: currentColor}"],
        changeDetection: 0
      });
    }
  }
  return NgDocPageLinkComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocPageLinkComponent };
